import script from "./ClearmentAuswahl.vue?vue&type=script&setup=true&lang=js"
export * from "./ClearmentAuswahl.vue?vue&type=script&setup=true&lang=js"

import "./ClearmentAuswahl.vue?vue&type=style&index=0&id=71eefa7a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71eefa7a"]])

export default __exports__